<script setup lang="ts">

defineOptions({
  name: 'Game'
});

import { useGameConfigStore } from '@/stores/gameConfig';
import { MyBalance } from '@/views/Common';
import { FlipCoin, Example, Example2, Example3 } from './componennts';

onMounted(() => {
  const { isSetConfig, updateAllConfig } = useGameConfigStore();
  if (!isSetConfig) {
    updateAllConfig();
  }
})

</script>

<template>
  <q-page class="column no-wrap">
    <MyBalance />
    <FlipCoin />
<!--    <Example3 />-->
  </q-page>
</template>

<style scoped>

</style>